import { Box, Button, Divider, Typography } from '@mui/material';
import React, { forwardRef, Suspense } from 'react';

import Loader from '../../../components/Loader/Loader';
import { IOneLinkChunkFormProps } from '../../../contexts/OneLinkSummaryProvider';

const TwoFASidebarContainer = React.lazy(
  () =>
    import(/* webpackChunkName: "sidebar-twofa" */ '../../../containers/TwoFASidebarContainer/TwoFASidebarContainer'),
);

const TwoFactorForm = forwardRef<boolean, IOneLinkChunkFormProps>(
  ({ onSubmit, instance, onClose }: IOneLinkChunkFormProps, ref) => {
    const handleSubmit = React.useCallback(() => {
      onSubmit({
        security_info: {
          enabled_2fa: false,
          allowed_domains: instance?.allowed_domains ?? [],
          max_submit_count: instance?.max_submit_count ?? 0,
          password: instance?.password ?? '',
        },
      });
    }, [instance?.max_submit_count, instance?.allowed_domains, instance?.password, onSubmit]);

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: 'baseline' }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Turning off 2FA will not remove confirmed recipients.
          </Typography>
          <Button onClick={handleSubmit} component="div" variant="outlined">
            Turn Off 2FA
          </Button>
        </Box>
        <Divider sx={{ mb: 1 }} />
        <Suspense fallback={<Loader isLoading />}>
          <TwoFASidebarContainer nested oneLinkId={instance?.uid} status={instance?.status} onClose={onClose} />
        </Suspense>
      </Box>
    );
  },
);

export default TwoFactorForm;
